import { render } from "./SignUpThanks.vue?vue&type=template&id=7d49d4ab"
import script from "./SignUpThanks.vue?vue&type=script&lang=js"
export * from "./SignUpThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__